<div
  class="run-detail"
  [class.highlight-success]="highlightType() === 'success'"
  [class.highlight-loss]="highlightType() === 'loss'"
>
  <div class="summary-stats">
    <div class="summary-card summary-card--trials">
      <div class="summary-card__label" [innerHTML]="nHtml"></div>
      <div class="summary-card__count">{{ summaryStats().total }}</div>
      <div class="summary-card__prob">Trials</div>
    </div>
    <div
      class="summary-card summary-card--success"
      (mouseenter)="highlightType.set('success')"
      (mouseleave)="highlightType.set(null)"
    >
      <div class="summary-card__icons">
        @for (svg of successSvgTypes(); track svg) {
          <dojo-outcome-svg [svgType]="svg" />
        }
      </div>
      <div class="summary-card__label">Success</div>
      <div class="summary-card__count">{{ summaryStats().successCount }}</div>
      <div class="summary-card__prob" [innerHTML]="empiricalSuccessHtml()"></div>
    </div>
    <div
      class="summary-card summary-card--loss"
      (mouseenter)="highlightType.set('loss')"
      (mouseleave)="highlightType.set(null)"
    >
      <div class="summary-card__icons">
        @for (svg of lossSvgTypes(); track svg) {
          <dojo-outcome-svg [svgType]="svg" />
        }
      </div>
      <div class="summary-card__label">Loss</div>
      <div class="summary-card__count">{{ summaryStats().lossCount }}</div>
      <div class="summary-card__prob" [innerHTML]="empiricalLossHtml()"></div>
    </div>
  </div>

  <div class="run-detail__section-title">Outcome</div>
  <dojo-experiment-results-table [results]="results()" />

  <div class="run-detail__section-title">Summary Statistics</div>
  <dojo-experiment-frequency-table
    [results]="results()"
    [experiment]="experiment()"
    [targetOutcomes]="targetOutcomes()"
    (highlightChange)="highlightType.set($event)"
    (mouseleave)="highlightType.set(null)"
  />
</div>
